const ReciveGiftCardConf = {
  'ReciveGiftCard.page.card_state': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'card_state',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ status, canReveal }) => {
        //         "0=电子贺卡
        // 1=贺卡待收下
        // 2=贺卡已失效
        // 3=贺卡已被他人收下
        // 4=贺卡待揭晓
        // 5=贺卡已收下
        // 5=贺卡待好友收下  （送礼人自己预览）
        // 6=贺卡已被收下     （送礼人自己预览）"
        const map = {
          1: 2,
          2: 3,
          3: 7,
          4: 1,
          5: !canReveal ? 4 : 0,
          6: 2,
          7: 2,
        };
        return `status=${map[status] !== undefined ? map[status] : '2'}`;
      },
    },
  },
  'ReciveGiftCard.page.go_home': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'go_homepage',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ u }) => {
        return `u=${u || '0'}`;
      },
    },
  },
  'ReciveGiftCard.page.receive': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'receive',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
};
export { ReciveGiftCardConf };
